import { useLocation } from 'react-router-dom';

// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import navigation from 'menu-items';

// ==============================|| HEADER CONTENT - PAGE TITLE ||============================== //
// Ikona + název aktuální stránky v navbaru (2026-08-22, na přání
// uživatele) - stejný lookup jako Breadcrumbs.jsx (menu-items/index.jsx's
// statický, neomezený strom - jen pro dohledání title/icon podle URL, ne
// pro řízení přístupu, viz ten soubor's docblock), jen jednodušší (bez
// breadcrumb hierarchie, jen "kde jsem teď").

// Rekurzivní (2026-08-30, real bug fixed - "Docházkový systém" jako vnořený
// subaccordion uvnitř "Manažeři" už není jen group -> collapse -> item, ale
// group -> collapse -> collapse -> item; pevná dvojitá smyčka by tuhle
// hlubší úroveň nikdy nenašla).
function findInChildren(children, pathname) {
  for (const child of children || []) {
    if (child.type === 'item' && child.url === pathname) return child;
    if (child.type === 'collapse') {
      const found = findInChildren(child.children, pathname);
      if (found) return found;
    }
  }
  return null;
}

function findCurrentItem(items, pathname) {
  for (const group of items || []) {
    const found = findInChildren(group.children, pathname);
    if (found) return found;
  }
  return null;
}

export default function PageTitle() {
  const location = useLocation();
  const pathname = location.pathname === '/' || location.pathname === '/dashboard' ? '/dashboard/default' : location.pathname;
  const item = findCurrentItem(navigation.items, pathname);

  if (!item) return <Stack sx={{ flexGrow: 1 }} />;

  const Icon = item.icon;

  return (
    <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', flexGrow: 1, ml: 1 }}>
      {Icon && <Icon style={{ fontSize: '1.3rem' }} />}
      <Typography variant="h6" sx={{ color: 'text.primary' }}>
        {item.title}
      </Typography>
    </Stack>
  );
}
